import { CONST_AWS_API } from 'src/app/core/constants';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CommanSubscribeService } from '../services/comman-subscribe.service';
import { Auth, API as AWS_API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { StorageService } from '../services/storage.service';

@Injectable({
    providedIn: 'root'
})
export class UserInfoGuard implements CanActivate, CanActivateChild {

    constructor(private commanSubscribeService: CommanSubscribeService,
        private storageService: StorageService,private router: Router,
        private ngxLoader: NgxUiLoaderService) {

    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        let userInfo = this.commanSubscribeService.userInfo;
        let user_Info = this.storageService.getItem("user_Info") || {};

        // return new Promise(res => {

        //     if (Object.keys(userInfo).length == 0) {
        //         this.ngxLoader.start();
        //         Auth.currentUserInfo()
        //             .then(user => {
        //                 if (user && user.attributes) {
        //                     let myInit = {
        //                         headers: {},
        //                         response: true,
        //                         body: {
        //                             email: user.attributes.email
        //                         }
        //                     }
        //                     AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER, myInit).then(response => {
        //                         this.ngxLoader.stop();
        //                         let userInfo = response.data.user;
        //                         userInfo.signedIn = true;
        //                         userInfo.access_token = userInfo.session_token;
        //                         this.commanSubscribeService.sendUserInfo(userInfo);
        //                         res(true);
        //                     }).catch(error => {
        //                         this.ngxLoader.stop();
        //                         res(true);
        //                     });
        //                 } else {
        //                     this.ngxLoader.stop();
        //                     res(true);
        //                 }
        //             }).catch(err => {
        //                 this.ngxLoader.stop();
        //                 res(true);
        //             });
        //     } else {
        //         res(true);
        //     }

        //     // let data = this.storageService.getItem("userInfo");
        //     // if (data && Object.keys(data).length != 0 && localStorage.isFanLoginUser) {
        //     //     res(true);
        //     // } else {
        //     //     res(true);
        //     // }
        // });

        return new Promise(res => {

            if (Object.keys(userInfo).length == 0 && Object.keys(user_Info).length != 0) {
                this.ngxLoader.start();
                let myInit = {
                    headers: {
                        "Content-Type": "application/json",
                        "x-api-key": environment.AWS_Cognito.X_Api_Key,
                        "Authorization": `Bearer ${user_Info.access_token}`
                    },
                    response: true,
                    body: {
                        // user_id: user_Info.id
                    }
                }
                AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER, myInit).then(response => {
                    this.ngxLoader.stop();
                    let userInfo = response.data.user;
                    userInfo.signedIn = true;
                    userInfo.access_token = userInfo.session_token;
                    // if(userInfo && userInfo.user_phone_number && userInfo.date_of_birth
                    //     && userInfo.user_display_name) {
                        userInfo.is_profile_completed = true;              
                    // } else {
                    //     userInfo.is_profile_completed = false;
                    //     this.router.navigateByUrl(`/user-dashboard/profile-settings/basic-info`);
                    // }
                    this.commanSubscribeService.sendUserInfo(userInfo);
                    res(true);
                }).catch(error => {
                    this.ngxLoader.stop();
                    this.commanSubscribeService.sendUserInfo({});
                    res(true);
                });
            } else {
                res(true);
            }
        });
    }
    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return true;
    }



}
